export const SCHEMA_CONTEXT_LINK = "http://schema.org";
